import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { Undo2, Redo2, Trash2, Eraser } from "lucide-react";
import { IncisionTemplateItem } from "../components/IncisionTemplateItem";
import { ClearCanvasDialog } from "@/components/dialogs/ClearCanvasDialog";
interface EditDeleteToolsProps {
  onUndo: () => void;
  onRedo: () => void;
  onDelete: () => void;
  onClear: () => void;
  hasSelection: boolean;
  canUndo?: boolean;
  canRedo?: boolean;
  icon: ReactNode;
  label: string;
}
export const EditDeleteTools = ({
  onUndo,
  onRedo,
  onDelete,
  onClear,
  hasSelection,
  canUndo = false,
  canRedo = false,
  icon,
  label
}: EditDeleteToolsProps) => {
  const handleDelete = () => {
    console.log("Delete selected button clicked, hasSelection:", hasSelection);
    if (hasSelection) {
      onDelete();
    }
  };
  return <div className="toolbar-item">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="modern-toolbar-button" aria-label={label}>
            <Eraser className="h-4 w-4" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="modern-toolbar-dropdown p-2 rounded-xl">
          <DropdownMenuLabel className="text-sm font-medium text-gray-600 px-1 py-1 mb-1">
            Edit &amp; Delete
          </DropdownMenuLabel>
          <DropdownMenuSeparator className="mb-2" />
          
          {/* Undo/Redo Section */}
          <div className="flex items-center justify-between gap-2 mb-2 px-1">
            <button onClick={onUndo} disabled={!canUndo} className={cn("flex items-center gap-2 py-1.5 px-3 rounded-md w-full transition-colors", canUndo ? "text-blue-600 bg-blue-50 hover:bg-blue-100" : "text-gray-400 bg-gray-100 cursor-not-allowed")}>
              <Undo2 className="h-4 w-4" />
              <span className="text-sm font-medium">Undo</span>
            </button>
            
            <button onClick={onRedo} disabled={!canRedo} className={cn("flex items-center gap-2 py-1.5 px-3 rounded-md w-full transition-colors", canRedo ? "text-blue-600 bg-blue-50 hover:bg-blue-100" : "text-gray-400 bg-gray-100 cursor-not-allowed")}>
              <Redo2 className="h-4 w-4" />
              <span className="text-sm font-medium">Redo</span>
            </button>
          </div>
          
          <DropdownMenuSeparator className="my-2" />
          
          {/* Delete Section */}
          <div className="flex items-center justify-between gap-2 px-1">
            {/* Delete Selected Button */}
            <button onClick={handleDelete} disabled={!hasSelection} className={cn("flex items-center gap-2 py-1.5 px-3 rounded-md w-full transition-colors", hasSelection ? "text-red-600 bg-red-50 hover:bg-red-100" : "text-gray-400 bg-gray-100 cursor-not-allowed")}>
              <Trash2 className="h-4 w-4" />
              <span className="text-sm font-medium">Selected</span>
            </button>
            
            {/* Clear Canvas Button */}
            <ClearCanvasDialog onClear={() => {
            console.log('ClearCanvasDialog: onClear callback executed');
            onClear();
          }} trigger={<button className="flex items-center gap-2 py-1.5 px-3 rounded-md w-full text-red-600 bg-red-50 hover:bg-red-100 transition-colors">
                  <Trash2 className="h-4 w-4" />
                  <span className="text-sm font-medium">All</span>
                </button>} />
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>;
};